import Browser from '@parameter1/base-cms-marko-web/browser';
import RefreshThemeShared from '@ac-business-media/refresh-theme/browser';

RefreshThemeShared(Browser);

export default Browser;
